export const URLS = {
  MAP_CREATE: 'map_api:map_translate',
  MAP_DELETE: 'map_api:settings:delete_map',
  MAP_DETAIL: 'map_api:map_translate',
  MAP_FAVORITE_CARD: 'map_api:favorite_card',
  MAP_FAVORITE_CARDS: 'map_api:favorite_cards'
};
